import { render } from "./LayoutContentRendererLeftDetached.vue?vue&type=template&id=429b46d4"
import script from "./LayoutContentRendererLeftDetached.vue?vue&type=script&lang=js"
export * from "./LayoutContentRendererLeftDetached.vue?vue&type=script&lang=js"
script.render = render

export default script